document.addEventListener('DOMContentLoaded', function() {
  const divMain = document.querySelector('.tags--horizontal');
  let position = divMain.firstElementChild.offsetLeft;
  const slideAmount = 150;
  const duration = 500;

  function smoothScroll(target, end) {
    const start = divMain.scrollLeft;
    const startTime = performance.now();

    function step(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
      divMain.scrollLeft = start + (end - start) * ease;
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  document.getElementById('arrow-right').addEventListener('click', function() {
    position += slideAmount;
    smoothScroll(divMain, position);
  });

  document.getElementById('arrow-left').addEventListener('click', function() {
    position -= slideAmount;
    smoothScroll(divMain, position);
  });
});